export default __webpack_public_path__ + "static/gallery-img2-6b378975cf3293b8f55e0f0f625faebe.jpg";